
import { OrbitControls, Environment } from "@react-three/drei";
import { useThree } from "@react-three/fiber";
import { useEffect } from "react";
import * as THREE from "three";

interface SceneSetupProps {
  enhancedLighting?: boolean;
}

// Component for standard lighting setup
const StandardLighting = () => (
  <>
    <ambientLight intensity={0.5} />
    <directionalLight
      position={[10, 10, 5]}
      intensity={1}
      castShadow
      shadow-mapSize={[2048, 2048]}
    />
    <fog attach="fog" args={['#87CEEB', 30, 100]} />
  </>
);

// Component for enhanced lighting setup
const EnhancedLighting = () => (
  <>
    <ambientLight intensity={0.3} />
    <directionalLight
      position={[10, 20, 15]}
      intensity={1.5}
      castShadow
      shadow-mapSize={[4096, 4096]}
      shadow-camera-left={-50}
      shadow-camera-right={50}
      shadow-camera-top={50}
      shadow-camera-bottom={-50}
    />
    <directionalLight 
      position={[-10, 10, -5]} 
      intensity={0.5} 
      color="#8fb3ff" 
    />
    <spotLight
      position={[0, 30, 0]}
      angle={0.3}
      penumbra={1}
      intensity={1}
      castShadow
      shadow-mapSize={[2048, 2048]}
    />
    <Environment preset="sunset" />
    <fog attach="fog" args={['#87CEEB', 40, 120]} />
  </>
);

// Camera controls configuration
const CameraControls = ({ enhancedDamping = false }) => (
  <OrbitControls 
    enableDamping={enhancedDamping}
    dampingFactor={0.1}
    enablePan={true}
    enableZoom={true}
    minPolarAngle={0}
    maxPolarAngle={Math.PI / 2.1}
  />
);

export const SceneSetup = ({ enhancedLighting = false }: SceneSetupProps) => {
  const { scene } = useThree();
  
  // Effect for any additional scene setup and cleanup
  useEffect(() => {
    if (enhancedLighting) {
      console.log("Setting up enhanced lighting");
      // Any additional setup can go here
      
      return () => {
        console.log("Cleaning up enhanced lighting");
        // Any cleanup can go here
      };
    }
  }, [enhancedLighting, scene]);

  return (
    <>
      <CameraControls enhancedDamping={enhancedLighting} />
      {enhancedLighting ? <EnhancedLighting /> : <StandardLighting />}
    </>
  );
};
